import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { notificationSchema } from "../../../Validations/notificationsValidation";
import { sendNotications } from "../../../apis/notificationApi";
import { uploadImageServer } from "../../../apis/newsApi";
import { getAppProducts } from "../../../apis/AppProductsApi";

export default function AddNotifications({ expoToken, onClose }) {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(false);
  const [success, setSuccess] = useState(false);
  const [productList, setProductList] = useState([]);

  const categoriesList = [
    "Investment Performance",
    "Fund Rule Updates",
    "Changes to Fund Rules",
    "Upcoming Events",
    "Important Dates",
    // 'Fund News',
    "Account Updates",
    "general",
  ];

  const NotificationContent = [
    {
      category: "Investment Performance",
      title: "📢 Your Investment Value has been updated!",
      body: "Open the app to check the latest fund performance.",
    },
    {
      category: "Fund Rule Updates",
      title: "⚠️ Important: Fund Rules Updated",
      body: `Review the latest changes to your fund's terms and conditions.`,
    },
    {
      category: "Changes to Fund Rules",
      title: "⚠️ Important: Action Required",
      body: `Review and approve the latest changes to your fund's terms and conditions.`,
    },
    {
      category: "Upcoming Events",
      title: `🗓️ Don't miss out: [event name]!`,
      body: ` Join us on [date] to [......]. Register now on the app.`,
    },
    {
      category: "Fund News",
      title: `📰 We have news: [headline]! `,
      body: `Stay informed with the latest updates on GM OPEN.`,
    },
    {
      category: "Account Updates",
      title: `📱 Complete your Profile to Start Investing!`,
      body: `Finish setting up your profile to unlock the full features of the GM OPEN app. It only takes 2 minutes to complete!`,
    },
    {
      category: "Important Dates",
      title: `🗓️ We've some important dates for your diary.`,
      body: `Don't miss out - add them to your diary now!`,
    },
  ];
  const germanNotificationContent = [
    {
      category: "Investment Performance",
      title: "📢 Der Wert Ihrer Anlage wurde aktualisiert!",
      body: "Öffnen Sie die App, um die aktuelle Fondsperformance zu sehen.",
    },
    {
      category: "Fund Rule Updates",
      title: "⚠️ Wichtig: Aktualisierung der Fondsregeln",
      body: "Bitte beachten Sie die Aktualisierung der allgemeinen Bedingungen Ihres Fonds.",
    },
    {
      category: "Changes to Fund Rules",
      title: "⚠️ Wichtig: Bestätigung erforderlich",
      body: "Bitte beachten und bestätigen Sie die neuesten Änderungen der Geschäftsbedingungen Ihres Fonds.",
    },
    {
      category: "Upcoming Events",
      title: "🗓️ Verpassen Sie es nicht: [Name der Veranstaltung]!",
      body: "Seien Sie dabei am [Datum] to [......]. Jetzt in der App anmelden.",
    },
    {
      category: "Fund News",
      title: "📰 Es gibt Neuigkeiten: [Überschrift/Schlagzeile]!",
      body: "Bleiben Sie auf dem Laufenden mit den neuesten Updates zu GM OPEN",
    },
    {
      category: "Account Updates",
      title:
        "📱Vervollständigen Sie Ihr Profil und beginnen Sie zu investieren!",
      body: "Nehmen Sie sich 2 Minuten Zeit und schließen Sie die Einrichtung Ihres Profils ab, um alle Funktionen der GM OPEN-App freizuschalten.",
    },
    {
      category: "Important Dates",
      title: "🗓️ Wir haben einige wichtige Termine für Ihren Kalender. ",
      body: "Verpassen Sie sie nicht – tragen sie die Termine jetzt in Ihren Kalender ein!",
    },
  ];
  const PolishNotificationContent = [
    {
      category: "Investment Performance",
      title: "📢 Wartość Twojej inwestycji została zaktualizowana!",
      body: "Otwórz aplikację, aby sprawdzić najnowsze wyniki funduszu.",
    },
    {
      category: "Fund Rule Updates",
      title: "⚠️ Ważne: Zasady funduszu zostały zaktualizowane",
      body: "Sprawdź najnowsze zmiany w warunkach i zasadach Twojego funduszu.",
    },
    {
      category: "Changes to Fund Rules",
      title: "⚠️ Ważne: Wymagana akcja",
      body: "Sprawdź i zatwierdź najnowsze zmiany w warunkach i zasadach Twojego funduszu.",
    },
    {
      category: "Upcoming Events",
      title: "🗓️ Nie przegap: [nazwa wydarzenia]!",
      body: "Dołącz do nas [data], aby [...]. Zarejestruj się teraz w aplikacji.",
    },
    {
      category: "Fund News",
      title: "📰 Mamy wiadomość: [nagłówek]!",
      body: "Bądź na bieżąco z najnowszymi aktualizacjami dotyczącymi GM OPEN.",
    },
    {
      category: "Account Updates",
      title: "📱 Uzupełnij swój profil, aby rozpocząć inwestowanie!",
      body: "Dokończ konfigurację swojego profilu, aby odblokować pełne funkcje aplikacji GM OPEN. Zajmie to tylko 2 minuty!",
    },
    {
      category: "Important Dates",
      title: "🗓️ Mamy dla Ciebie kilka ważnych dat.",
      body: "Nie przegap ich – dodaj je teraz do swojego kalendarza!",
    },
  ];

  const uploadFile = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const path = await uploadImageServer(formData);
    if (path) {
      formik.setFieldValue("image", path.path);
    }
  };

  const formik = useFormik({
    initialValues: {
      expoPushToken: expoToken || "",
      category: "",
      title: "GM OPEN",
      body: "",
      email: "",
      image: "",
      linking: "",
      eventTitle: "",
      startDate: "",
      endDate: "",
      gmoId: "",
      role: "",
      screen: "",
      itemId: "",
      manual: true,
      scheduledTime: "",
      timeZone: "",
      deTitle: "",
      deBody: "",
      plTitle: "",
      plBody: "",
      documentTitle: "",
      documentUrl: "",
      crmProductId: "",
    },
    validationSchema: notificationSchema,
    onSubmit: async (values) => {
      console.log(values, " values vlauessjsksksjvskvskjs");
      try {
        setLoading(true);
        const payload = {
          expoPushToken: values.expoPushToken || "",
          category: values.category || "",
          email: values.email || "",
          image: values.image || "",
          linking: values.linking || "",
          eventTitle: values.eventTitle || "",
          startDate: values.startDate || "",
          endDate: values.endDate || "",
          gmoId: values.gmoId || "",
          role: values.role || "",
          screen: values.screen || "",
          itemId: values.itemId || "",
          crmProductId: values.crmProductId || "",
          manual: true,
          en: {
            title: values.title || "",
            body: values.body || "",
          },
          de: {
            title: values.deTitle || "",
            body: values.deBody || "",
          },
          pl: {
            title: values.plTitle,
            body: values.plBody,
          },
          documentTitle: values.documentTitle || "",
          documentUrl: values.documentUrl || "",
        };
        const res = await sendNotications(payload);
        console.log(res);
        setLoading(false);
        formik.resetForm();
        setSuccess(true);
      } catch (error) {
        console.error("Error submitting form:", error);
        setLoading(false);
      }
    },
  });
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const upload = await uploadImageServer(formData);
      formik.setFieldValue("documentUrl", upload.path);
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  };
  const getCurrentDateTime = () => {
    const now = new Date();
    let year = now.getFullYear();
    let month = String(now.getMonth() + 1).padStart(2, "0");
    let day = String(now.getDate()).padStart(2, "0");
    let hours = now.getHours();
    let minutes = now.getMinutes() + 1;

    if (minutes >= 60) {
      minutes = 0;
      hours += 1;
    }

    if (hours >= 24) {
      hours = 0;
      const nextDay = new Date(now);
      nextDay.setDate(now.getDate() + 1);
      year = nextDay.getFullYear();
      month = String(nextDay.getMonth() + 1).padStart(2, "0");
      day = String(nextDay.getDate()).padStart(2, "0");
    }

    hours = String(hours).padStart(2, "0");
    minutes = String(minutes).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const TIME_ZONES = [
    { label: "(UTC) Coordinated Universal Time", value: "UTC" },
    { label: "(IST) India Standard Time", value: "Asia/Kolkata" },
    { label: "(EST) Eastern Time", value: "America/New_York" },
    { label: "(CST) Central Time", value: "America/Chicago" },
    { label: "(PST) Pacific Time", value: "America/Los_Angeles" },
    { label: "(GMT) Greenwich Mean Time", value: "Europe/London" },
    { label: "(CET) Central European Time", value: "Europe/Paris" },
    { label: "(AEST) Australia Eastern Time", value: "Australia/Sydney" },
  ];
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await getAppProducts();
      setProductList(res?.result || []);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  return (
    <>
      {success ? (
        <div>
          <h5 className="text-success h5 mt-4">Success</h5>
          <div className="mt-3 d-flex">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                onClose();
                setSuccess(false);
              }}
            >
              <span aria-hidden="true">Close</span>
            </button>
          </div>
        </div>
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Category</label>
            <select
              name="category"
              className="form-control"
              value={formik.values.category}
              // onChange={(e) => {
              //   const selectedCategory = e.target.value;
              //   formik.setFieldValue("category", selectedCategory);

              //   const contentObj = NotificationContent.find(
              //     (item) => item.category === selectedCategory,
              //   );
              //   if (contentObj) {
              //     formik.setFieldValue("title", contentObj.title);
              //     formik.setFieldValue("body", contentObj.body);
              //   } else {
              //     formik.setFieldValue("body", "");
              //   }
              // }}
              onChange={(e) => {
                const selectedCategory = e.target.value;
                formik.setFieldValue("category", selectedCategory);

                // English
                const enContent = NotificationContent.find(
                  (item) => item.category === selectedCategory,
                );

                if (enContent) {
                  formik.setFieldValue("title", enContent.title);
                  formik.setFieldValue("body", enContent.body);
                } else {
                  formik.setFieldValue("title", "");
                  formik.setFieldValue("body", "");
                }

                // German
                const deContent = germanNotificationContent.find(
                  (item) => item.category === selectedCategory,
                );

                if (deContent) {
                  formik.setFieldValue("deTitle", deContent.title);
                  formik.setFieldValue("deBody", deContent.body);
                } else {
                  formik.setFieldValue("deTitle", "");
                  formik.setFieldValue("deBody", "");
                }

                // Polish
                const plContent = PolishNotificationContent.find(
                  (item) => item.category === selectedCategory,
                );

                if (plContent) {
                  formik.setFieldValue("plTitle", plContent.title);
                  formik.setFieldValue("plBody", plContent.body);
                } else {
                  formik.setFieldValue("plTitle", "");
                  formik.setFieldValue("plBody", "");
                }
              }}
              onBlur={formik.handleBlur}
            >
              <option value="">Select Category</option>
              {categoriesList.map((cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
            {formik.touched.category && formik.errors.category && (
              <div className="text-danger">{formik.errors.category}</div>
            )}
          </div>

          {formik.values.category !== "" && (
            <>
              <div className="mb-3">
                <label className="form-label">Notification Title</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter the notification Title"
                  name="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.title && formik.errors.title && (
                  <div className="text-danger">{formik.errors.title}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  name="body"
                  placeholder="Enter the notification Message"
                  value={formik.values.body}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.body && formik.errors.body && (
                  <div className="text-danger">{formik.errors.body}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">German Notification Title</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter the German notification Title"
                  name="deTitle"
                  value={formik.values.deTitle}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // readOnly={true}
                />
                {formik.touched.deTitle && formik.errors.deTitle && (
                  <div className="text-danger">{formik.errors.deTitle}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">German Message</label>
                <textarea
                  className="form-control"
                  name="deBody"
                  placeholder="Enter the German notification Message"
                  value={formik.values.deBody}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // readOnly={true}
                />
                {formik.touched.deBody && formik.errors.deBody && (
                  <div className="text-danger">{formik.errors.deBody}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Polish Notification Title</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter the Polish notification Title"
                  name="plTitle"
                  value={formik.values.plTitle}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // readOnly={true}
                />
                {formik.touched.plTitle && formik.errors.plTitle && (
                  <div className="text-danger">{formik.errors.plTitle}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Polish Message</label>
                <textarea
                  className="form-control"
                  name="plBody"
                  placeholder="Enter the Polish notification Message"
                  value={formik.values.plBody}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // readOnly={true}
                />
                {formik.touched.plBody && formik.errors.plBody && (
                  <div className="text-danger">{formik.errors.plBody}</div>
                )}
              </div>

              <div className="input-block">
                <label className="form-label">
                  Image (size should be less than 1 mb)
                </label>
                <input
                  className="form-control"
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={uploadFile}
                  onBlur={formik.handleBlur}
                  placeholder="Upload File"
                  style={{ width: "250px" }}
                />
                {formik.errors.image && formik.touched.image && (
                  <span className="text-danger">{formik.errors.image}</span>
                )}
                {formik.values.image && (
                  <img src={formik.values.image} width={300} />
                )}
              </div>

              {formik.values.category === "Upcoming Events" && (
                <div className="mb-3">
                  <label className="form-label">Link</label>
                  <input
                    className="form-control"
                    type="url"
                    name="linking"
                    placeholder="Enter the link"
                    value={formik.values.linking}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.linking && formik.errors.linking && (
                    <div className="text-danger">{formik.errors.linking}</div>
                  )}
                </div>
              )}

              {formik.values.category === "Important Dates" && (
                <div>
                  <div className="mb-3">
                    <label className="form-label">Event Title</label>
                    <input
                      className="form-control"
                      type="text"
                      name="eventTitle"
                      placeholder="Enter the Event Title"
                      value={formik.values.eventTitle}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.eventTitle && formik.errors.eventTitle && (
                      <div className="text-danger">
                        {formik.errors.eventTitle}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Start Date</label>
                    <input
                      className={`form-control ${
                        formik.touched.startDate && formik.errors.startDate
                          ? "is-invalid"
                          : ""
                      }`}
                      type="datetime-local"
                      name="startDate"
                      value={formik.values.startDate}
                      min={getCurrentDateTime()}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.startDate && formik.errors.startDate && (
                      <div className="text-danger">
                        {formik.errors.startDate}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">End Date</label>
                    <input
                      className={`form-control ${
                        formik.touched.endDate && formik.errors.endDate
                          ? "is-invalid"
                          : ""
                      }`}
                      type="datetime-local"
                      name="endDate"
                      value={formik.values.endDate}
                      min={formik.values.startDate || getCurrentDateTime()}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.endDate && formik.errors.endDate && (
                      <div className="text-danger">{formik.errors.endDate}</div>
                    )}
                  </div>
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">
                  Email (To send a single user)
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter the Email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="text-danger">{formik.errors.email}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">User Type</label>
                <select
                  className="form-control"
                  name="role"
                  value={formik.values.role}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select User Type</option>

                  {formik.values.category === "Account Updates" && (
                    <option value="user">User</option>
                  )}

                  {formik.values.category === "Investment Performance" && (
                    <>
                      <option value="broker">Broker</option>
                      <option value="user">User</option>
                    </>
                  )}

                  {formik.values.category !== "Account Updates" &&
                    formik.values.category !== "Investment Performance" && (
                      <>
                        <option value="all">All</option>
                        <option value="broker">Broker</option>
                        <option value="user">User</option>
                      </>
                    )}
                </select>

                {formik.touched.role && formik.errors.role && (
                  <div className="text-danger">{formik.errors.role}</div>
                )}
              </div>
              {/* Product */}
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Product <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  name="crmProductId"
                  value={formik.values.crmProductId}
                  onChange={formik.handleChange}
                >
                  <option value="">Select Product</option>
                  {productList.map((p) => (
                    <option key={p.id} value={p.crmProductId}>
                      {p.name}
                    </option>
                  ))}
                </select>
                {formik.errors.crmProductId && formik.touched.crmProductId && (
                  <span className="text-danger">
                    {formik.errors.crmProductId}
                  </span>
                )}
              </div>
              {/* ScheduleTime */}
              <div className="mb-3">
                <label className="form-label">Schedhule Time</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="scheduledTime"
                  value={formik.values.scheduledTime}
                  onChange={formik.handleChange}
                />

                {formik.touched.scheduledTime &&
                  formik.errors.scheduledTime && (
                    <div className="text-danger">
                      {formik.errors.scheduledTime}
                    </div>
                  )}
              </div>
              {/* Time Zone */}
              <div className="mb-3">
                <label className="form-label">Time Zone</label>
                <select
                  className="form-control"
                  name="timeZone"
                  value={formik.values.timeZone}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select Time Zone</option>
                  {TIME_ZONES.map((tz) => (
                    <option key={tz.value} value={tz.value}>
                      {tz.label}
                    </option>
                  ))}
                </select>

                {formik.touched.timeZone && formik.errors.timeZone && (
                  <div className="text-danger">{formik.errors.timeZone}</div>
                )}
              </div>

              {/* documentTitle */}
              <div className="mb-3">
                <label className="form-label">Document Title</label>
                <input
                  type="Text"
                  className="form-control"
                  name="documentTitle"
                  value={formik.values.documentTitle}
                  onChange={formik.handleChange}
                />

                {formik.touched.documentTitle &&
                  formik.errors.documentTitle && (
                    <div className="text-danger">
                      {formik.errors.documentTitle}
                    </div>
                  )}
              </div>
              {/* documentUrl */}
              <div className="mb-3">
                <label className="form-label">Document URL</label>
                <input
                  type="file"
                  accept=".pdf"
                  className="form-control mb-2"
                  onChange={handleFileUpload}
                />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Or paste document URL"
                  name="documentUrl"
                  value={formik.values.documentUrl}
                  onChange={formik.handleChange}
                />
                {formik.values.documentUrl && (
                  <a
                    href={formik.values.documentUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="d-block mt-2"
                  >
                    View Document
                  </a>
                )}
                {/* <input
                  type="Text"
                  className="form-control"
                  name="documentUrl"
                  value={formik.values.documentUrl}
                  onChange={formik.handleChange}
                /> */}

                {formik.touched.documentUrl && formik.errors.documentUrl && (
                  <div className="text-danger">{formik.errors.documentUrl}</div>
                )}
              </div>
              {/* <div className='mb-3'>
                <label className='form-label'>User Type</label>
                <select
                  className='form-control'
                  name='role'
                  value={formik.values.role}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value=''>Select User Type</option>
                  {formik.values.category !== 'Investment Performance' && (
                    <option value='all'>All</option>
                  )}
                  {formik.values.category == 'Account Updates' && (
                    <option value='user'>User</option>
                  )}
                  <option value='user'>User</option>
                  <option value='broker'>Broker</option>
                </select>
                {formik.touched.role && formik.errors.role && (
                  <div className='text-danger'>{formik.errors.role}</div>
                )}
              </div> */}

              {formik.values.category !== "Upcoming Events" && (
                <>
                  <div onClick={() => setDetail(!detail)}>
                    Developer Additional Info {detail ? "-" : "+"}
                  </div>
                  {detail && (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">Screen</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter the ScreenName"
                          name="screen"
                          value={formik.values.screen}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Item Id</label>
                        <input
                          className="form-control"
                          type="number"
                          placeholder="Enter the Item Id"
                          name="itemId"
                          value={formik.values.itemId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-secondary me-2"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Sending..." : "Submit"}
            </button>
          </div>
        </form>
      )}
    </>
  );
}
